<div class="md-content rd-3 document-preview">
  <div class="md-header d-flex align-items-center justify-content-between">
    <h3 class="truncate mb-0 pr-3">{{ attachment?.fileName }}</h3>
    <div class="d-flex align-items-center">
      <div dropdown class="mr-2 position-relative">
        <button dropdownToggle type="button" class="btn btn-md btn-secondary">
          <span class="d-flex align-items-center">
            {{ 'GENERAL.options' | translate }}
            <i class="material-icons icon ml-1">more_horiz</i>
          </span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
          <li>
            <a class="dropdown-item" (click)="downloadAttachment()">
              {{ 'DASHBOARD.documentPreviewModal.downloadAttachment' | translate }}
            </a>
          </li>
          @if (canDelete) {
            <li>
              <a class="dropdown-item text-danger" (click)="deleteAttachment()">
                {{ 'DASHBOARD.documentPreviewModal.deleteAttachment' | translate }}
              </a>
            </li>
          }
        </ul>
      </div>
      <i class="material-icons md-close" (click)="close()">close</i>
    </div>
  </div>

  <div class="md-body preview-body">
    @if (loading) {
      <div class="d-flex w-100 justify-content-center p-3">
        <app-loader />
      </div>
    }

    @if (visualizer === 'image') {
      <img [src]="fileUrl" alt="" class="preview-image" />
    }

    @if (visualizer === 'pdf') {
      <iframe
        [src]="fileUrl"
        class="preview-iframe"
        referrerpolicy="no-referrer"
        (load)="onPdfLoaded()"
      ></iframe>
    }

    @if (visualizer === 'other') {
      <div class="text-center p-4">
        <i class="material-icons preview-off">visibility_off</i>
        <p class="text-primary text-bold mb-1">{{ 'DASHBOARD.documentPreviewModal.cannotPreview' | translate }}</p>
        <p class="text-secondary text-small mb-3">{{ 'DASHBOARD.documentPreviewModal.downloadToView' | translate }}</p>
        <button type="button" class="btn btn-md btn-primary" (click)="downloadAttachment()">
          {{ 'DASHBOARD.documentPreviewModal.download' | translate }}
        </button>
      </div>
    }
  </div>
</div>
